import React from 'react';
import {
	BrowserRouter as Router,
	Route,
	Switch
} from 'react-router-dom';
import { SWRConfig } from 'swr';

import Fonts from './global-styles/fonts';
import Header from './Common/Header';
import Home from './Home';
import OAuthCallback from './OAuthCallback';
import Services from './Services';
import ServiceSpecification from './ServiceSpecification';
import NotFound from './NotFound';
import { oauthRedirectPath } from './util/constants';
import swrFetcher from './util/swr-fetcher';

const swrConfig = {
	fetcher: swrFetcher,
	revalidateOnFocus: false
};

function App() {
	return (
		<SWRConfig value={swrConfig}>
			<Fonts />
			<Router>
				<Switch>
					<Route path="/:versionSlug?" children={({ match }) => {

						const { versionSlug } = match.params;

						return (
							<Header
								servicesLinkTarget={versionSlug ? `/${versionSlug}/services` : ''}
							/>
						);
					}} />
				</Switch>
				<Switch>
					<Route path="/" exact component={Home} />
					<Route path={oauthRedirectPath} exact component={OAuthCallback} />
					<Route path="/:versionSlug/services" exact component={Services} />
					<Route path="/:versionSlug/service/:serviceCode" exact component={ServiceSpecification} />
					<Route path="*" component={NotFound} />
				</Switch>
			</Router>
		</SWRConfig>
	);
}

export default App;
